import {transactionsReducer} from './transactions';

export * from './transactions';

export const applicationReducer = {
    transactions: transactionsReducer
};

export type ApplicationState = typeof applicationReducer;
